<div class="link-expired-screen">
              
    <div class="link-expired-screen-img"><img src="assets/images/link-expired.png">
        <p>Link has expired. Please contact the host.</p>
    </div>                
</div>